import { combineEpics, ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { catchError, map, mergeMap, pluck, startWith } from 'rxjs/operators'

import * as actions from './actions'
import * as api from './api'

const fetchAssistantAgentSettings = (action$) => {
  return action$.pipe(
    ofType(actions.fetchAssistantAgentSettings.toString()),
    mergeMap(() =>
      from(api.fetchAssistantAgentSettings()).pipe(
        startWith(actions.fetchAssistantAgentSettingsPending()),
        map((data) => actions.fetchAssistantAgentSettingsSuccess(data)),
        catchError((err) =>
          of(actions.fetchAssistantAgentSettingsFailed({ err }))
        )
      )
    )
  )
}

const patchAssistantAgentSettings = (action$) => {
  return action$.pipe(
    ofType(actions.patchAssistantAgentSettings.toString()),
    pluck('payload'),
    mergeMap((newSettings) =>
      from(api.patchAssistantAgentSettings(newSettings)).pipe(
        startWith(actions.patchAssistantAgentSettingsPending()),
        map((data) => actions.patchAssistantAgentSettingsSuccess(data)),
        catchError((err) =>
          of(actions.patchAssistantAgentSettingsFailed({ err }))
        )
      )
    )
  )
}

export default combineEpics(
  fetchAssistantAgentSettings,
  patchAssistantAgentSettings
)
